import SuperAgentProvinceScreen from "./SuperAgentScreen.province.context";
import SuperAgentCityScreen from "./SuperAgentScreen.city.context";
import SuperAgentScreen from "./SuperAgentScreen.context";
import CompanyScreen from "./CompanyScreen.context";
import StudentScreen from "./StudentScreen.context";
import ServiceScreen from "./ServiceScreen.context";
import SchoolScreen from "./SchoolScreen.context";
import DriverScreen from "./DriverScreen.context";
import ParentScreen from "./ParentScreen.context";
import AbsentScreen from "./AbsentScreen.context";
import LogScreen from "./LogScreen.context";
import FinancialGroupScreen from "./FinancialGroup.context";
import TransactionsScreen from "./Transactions.context";
import WithdrawalScreen from "./WithdrawalScreen.context";
import MunicipulityScreen from "./municipulity.context";
import GovernmentShipScreen from "./GovernmentShip.context";
import UserScreen from "./User.context";
import AcademicYear from "./AcademicYear.context";
import AcademicYearScreen from "./AcademicYearScreen.context";
import UploadDocumentContext from "./UploadDocument.context";
import TicketScreen from "./Ticket.context";
import DebtScreen from "./DebtToDriverScreen.context";
import DebtsScreen from "./DebtsScreen.context";
import CompanyFactorScreen from "./CompanyFactorScreen";
import payAdminToDriverContext from "./payAdminToDriverScreen";
import ParentTransactionScreen from "./ParentTransaction.context";
import ApproveParentTransactionScreen from "./ApproveParentTransaction.context";
import DriverTransactionScreen from "./DriverTransaction.context";
import RejectedParentTransaction from "./RejectedParentTransaction.context";
import OnlineDriverTransactionScreen from "./OnlineDriverTransactionScreen.context";
import WithdrawalCompanyScreen from "./WithdrawalCompanyScreen.context";
import FactorsNeedPay2CompanyScreenContext from './FactorsNeedPay2CompanyScreen.context';
import PaymentOnline2CompanyContext from './PaymentOnline2Company.context';

import * as Location from './location.context';

const Context = {
  Location,
  AcademicYear,
  AcademicYearScreen,
  SuperAgentProvinceScreen,
  SuperAgentCityScreen,
  CompanyScreen,
  ServiceScreen,
  StudentScreen,
  SchoolScreen,
  DriverScreen,
  ParentScreen,
  AbsentScreen,
  LogScreen,
  FinancialGroupScreen,
  TransactionsScreen,
  WithdrawalScreen,
  MunicipulityScreen,
  SuperAgentScreen,
  GovernmentShipScreen,
  UserScreen,
  UploadDocumentContext,
  TicketScreen,
  DebtScreen,
  DebtsScreen,
  CompanyFactorScreen,
  payAdminToDriverContext,
  ApproveParentTransactionScreen,
  DriverTransactionScreen,
  ParentTransactionScreen,
  RejectedParentTransaction,
  OnlineDriverTransactionScreen,
  WithdrawalCompanyScreen,
  PaymentOnline2CompanyContext,
  FactorsNeedPay2CompanyScreenContext,
};

export default Context;
